import React from 'react';
import { Button, makeStyles, Paper, Typography } from "@material-ui/core";
import { useAppConfig } from '../../../utilities/useAppConfig';
import { useIsMobile } from '../../../components/Mui3WidthProvider';

const useStyles = makeStyles((theme) => ({
    section: {
        margin: '0 auto',
        marginTop: theme.spacing(4),
        [theme.breakpoints.up("sm")]: {
            width: "60%",
            marginBottom: theme.spacing(6),
            padding: theme.spacing(4),
        },
        [theme.breakpoints.down("xs")]: {
            width: "100%",
            paddingLeft: theme.spacing(2),
            paddingRight: theme.spacing(2),
            marginBottom: 30,
            marginTop: 10,
        },
    },
}));

export function AccountInfo() {
    const [config,] = useAppConfig();
    const isMobile = useIsMobile();
    const classes = useStyles();

    const onChangeEmail = () => {
        window.location.assign(`${config.accountSiteUrl}/account/change-email`);
    }

    const onChangePassword = () => {
        window.location.assign(`${config.accountSiteUrl}/account/change-password`);
    }

    return (
        <React.Fragment>
            {isMobile && <Typography style={{ marginTop: 8, marginBottom: -8 }} variant="h5">My Account</Typography>}
            <Paper className={classes.section} elevation={2}>
                {!isMobile && <Typography variant="h5">My Account</Typography>}
                <Button
                    color="primary"
                    style={{ marginTop: 20 }}
                    onClick={onChangeEmail}
                >
                    Change Email
                </Button>
                <Button
                    color="primary"
                    style={{ marginTop: 20 }}
                    onClick={onChangePassword}
                >
                    Change Password
                </Button>
            </Paper>
        </React.Fragment>
    );
}